import cls from "./customRadio.module.scss"
import {ChangeEvent, Dispatch, FC, SetStateAction} from "react";
import {optionItemType} from "../../../types/homePageTypes";

interface ICustomSelect {
    selectArray: Array<optionItemType>;
    setOptionQuantity: Dispatch<SetStateAction<optionItemType[]>>
    optionQuantity: Array<optionItemType>
}


const CustomRadio: FC<ICustomSelect> = (
    {
        selectArray,
        setOptionQuantity,
        optionQuantity
    }
) => {
    const defaultValueExist = selectArray?.find((item) => !!item.is_default)
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = JSON.parse(e.target.value)
        const findOptQty = optionQuantity.find(({bundleOptionId}) => bundleOptionId === value.bundleOptionId);
        if (findOptQty) {
            setOptionQuantity(prevState => {
                const spliceThisItem = prevState
                    .filter(filteredElem => filteredElem.bundleOptionId !== findOptQty?.bundleOptionId)
                return [...spliceThisItem, value]
            })
        }
    }
    return (
        <div className={cls.main}>
            {selectArray?.map((elem) => {
                return (
                    <div className={cls.optionMain} key={elem.id as number}>
                        <input
                            defaultChecked={defaultValueExist && elem.id === defaultValueExist.id}
                            type="radio"
                            id={`${elem.id}`}
                            name="option"
                            value={JSON.stringify(elem)}
                            onChange={handleChange}
                        />
                        <label htmlFor={`${elem.id}`}>{elem.name}</label>
                    </div>
                )
            })}
        </div>
    )
};

export default CustomRadio;
